import FeedbackPlus from './feedbackplus';

type GetImageParams = {
	bitmap: ImageBitmap;
	canvas: HTMLCanvasElement;
	height: number;
	width: number;
};
export const getImage = ({ width, height, bitmap, canvas }: GetImageParams) => {
	const resizedWidth = width;
	const resizedHeight = height;
	canvas.width = resizedWidth;
	canvas.height = resizedHeight;
	// Draw the bitmap onto the canvas
	const ctx = canvas.getContext('2d');
	if (!ctx) {
		// Return an error message directly if canvas context is not available
		throw new Error('Failed to get canvas context.');
	}
	ctx.drawImage(bitmap, 0, 0, width, height);
	// Convert the canvas to a Base64 string; Using jpeg because it's smaller
	const base64Image = canvas.toDataURL('image/jpeg', 0.8);
	const base64Data = base64Image.split(',')[1];
	// Calculate the size of the Base64 data:
	// Each Base64 character represents 6 bits, so multiply by 3/4 to get the byte count
	const base64DataSizeInBytes = (base64Data.length * 3) / 4;

	return { imageSize: base64DataSizeInBytes, imageData: base64Data };
};

export interface ScreenshotReturnType {
	imageData: string;
	imageSize: number;
	startImageSize: number;
}
export const captureScreenShot = async (): Promise<ScreenshotReturnType> => {
	const feedbackPlus = new FeedbackPlus();
	const canvas = document.createElement('canvas');
	try {
		const { bitmap, width, height } = await feedbackPlus.capture();
		let count = 0;
		let currentWidth = width;
		let currentHeight = height;
		const { imageSize, imageData } = getImage({
			width: currentWidth,
			height: currentHeight,
			bitmap,
			canvas,
		});
		let finalImageData = imageData;
		let currentImageSize = imageSize;
		const startImageSize = imageSize;
		const widthPercentage = 720 / currentWidth;
		const heightPercentage = 1080 / currentHeight;
		const scale = widthPercentage > heightPercentage ? widthPercentage : heightPercentage;
		while (currentImageSize > 150000 && count <= 5) {
			currentWidth = currentWidth * scale;
			currentHeight = currentHeight * scale;
			const { imageSize, imageData } = getImage({
				width: currentWidth,
				height: currentHeight,
				bitmap,
				canvas,
			});
			currentImageSize = imageSize;
			finalImageData = imageData;

			count++;
		}

		// last catch just in case.
		// just throw an error
		if (currentImageSize > 150000) {
			return {
				startImageSize,
				imageData: `Image size of ${currentImageSize} bytes exceeds the maximum allowed size of 150 kB.`,
				imageSize: currentImageSize,
			};
		}
		return { imageData: finalImageData, imageSize: currentImageSize, startImageSize };
	} catch (error) {
		return {
			imageData: `Error: ${error instanceof Error ? error.message : 'Unknown error'}`,
			imageSize: 0,
			startImageSize: 0,
		};
	}
};
